import { useTranslation } from 'react-i18next';

import { AccessoryTabProps } from 'components/desktop/Accessory/AccessoryComponent';
import FoldableCard from 'components/desktop/_general/Card/FoldableCard/FoldableCard';
import RoundedInput from 'components/desktop/_general/Input/RoundedInput/RoundedInput';
import PERMISSIONS from 'enums/permissions';
import { arePermissionsInUserPermissions } from 'functions/tokenFunctions';
import useCurrency from 'hooks/redux/useCurrency';

export const AccessoryPriceCard = ({ state, handlers }: AccessoryTabProps): JSX.Element => {
	const { t } = useTranslation();
	const currency: string = useCurrency();

	const isAccessoryEditor: boolean = arePermissionsInUserPermissions([
		PERMISSIONS.WRITEACCESSORY,
	]);

	const getLabelPrice = (): string => {
		return `${currency} ${t('_general:PER')} 100g`;
	};

	return (
		<FoldableCard
			defaultOpen={true}
			dataComponentType="accessory-price-card"
			title={t('_general:PRICE')}
			content={
				<div className="card-body">
					<label>{getLabelPrice()}</label>
					<RoundedInput
						disabled={!isAccessoryEditor}
						error-key="Price"
						handleChange={handlers.setPrice}
						name="price"
						value={state.price ?? 0}
					/>
				</div>
			}
		/>
	);
};
